/** CSS variables for the Kepler service's visual theme. */
export const theme = {
  '--basefont': '"Exo 2", sans-serif',
  '--primary-darken': 'var(--kepler-green-dark)',
  '--primary': 'var(--kepler-green)' /* variable semantica para color corporativo */,
  '--charcoal-grey': 'var(--kepler-black)',
  '--kepler-black': '#232633',
  '--kepler-green': '#0e9db3',
  '--kepler-green-dark': '#0a7485'
};
